import { createContext } from 'react';

const LocationsContext = createContext({});

export default LocationsContext;